import { gsap } from 'gsap';
import $ from 'jquery';
import initHeader from './components/header';
import initHero from './components/hero';
import initShowreel from './components/showreel';
import initTestimonials from './components/testimonials';
import initKnowledge from './components/knowledge';
import initMarquee from './components/marquee';
import initLenisScroll from './components/lenisScroll';
import initPreloader, { onPreloaderDone } from './components/preloader';
import initSmoothScroll from './components/smoothScroll';
import initSinglePost from './components/single-post';
import initFaqAccordions from './components/faq';
import initPricingCompare from './components/pricing';
import initEbookGrid from './components/ebook-grid';
import initBlogArchive from './components/blog-archive';
import initAcademyGrid from './components/academy-grid';
import initWebinarGrid from './components/webinar-grid';
import initWebinarSingle from './components/webinar-single';
import initWebStudio from './components/web-studio';
import initPortfolioParallax from './components/portfolio-parallax';
import initPortfolioResults from './components/portfolio-results';
import initPortfolioGrid from './components/portfolio-grid';
import initRoadmap from './components/roadmap';
import initBackToTop from './components/backToTop';
import initButtonArrows from './components/buttonArrows';
import initWebsiteBrief from './components/websiteBrief';
import initContactForms from './components/contactForm';
import initSupportPopup from './components/supportPopup';
import initReveal from './components/reveal';
import initServiceCardLinks from './components/serviceCardLink';
import initGrowthMedia from './components/growthMedia';

$(document).ready(() => {
  console.log('klikdigital theme loaded');

  // Global smooth scrolling (Lenis) — set up first so ScrollTrigger-driven
  // animations below hook into the smoothed scroll position.
  initLenisScroll();

  // Preloader: Klik mark intro + progress, then a lime burst wipes it away.
  initPreloader();

  // Header: mobile menu, sub-menu expand, scrolled state.
  initHeader();

  // Hero: stats count-up.
  onPreloaderDone(initHero);

  // Showreel: scroll-scale animation + video popup.
  initShowreel();

  // Testimonials: desktop auto-scroll marquee + mobile Swiper slider.
  initTestimonials();

  // Knowledge: tabbed Insights/Webinars cards fetched from the REST API.
  initKnowledge();

  // Marquee: two "LET`S GET STARTED" rows scrolling in opposite directions
  // (seamless GSAP horizontalLoop reused from the old web-studio running line).
  initMarquee();

  // Smooth scroll: any "#anchor" link glides to the matching element,
  // offset for the sticky header.
  initSmoothScroll();

  // Services cards: the running gradient border is pure CSS (always-on).
  // This only makes the whole card follow its own "Learn more" link.
  initServiceCardLinks();

  // Growth cards: contain (not crop) wide diagram images on tablet/mobile.
  initGrowthMedia();

  // Single post: copy-link button, audio-plugin button skin.
  initSinglePost();

  // FAQ accordion: every klikdigital/faq-list on the page (single posts,
  // .section-faq wrappers on service/industry pages).
  initFaqAccordions();

  // Pricing: "Compare all features" slide-open comparison table.
  initPricingCompare();

  // Ebook Grid: filter tags show/hide cards by ebooks-category.
  initEbookGrid();

  // Blog Archive: category filter + "Learn more" pagination via REST.
  initBlogArchive();

  // Klik Academy Grid: category filter + Fancybox video popups.
  initAcademyGrid();

  // Webinar Grid: category + "Upcoming (Live)" filter, "Learn more" reveal.
  initWebinarGrid();

  // Single Webinar page: live countdown ticker toward the webinar's date/time.
  initWebinarSingle();

  // Web Studio landing: cursor, magnetic pills, scroll scrubs, industries
  // hover, ticker, landing header/burger menu, CF7 modal. No-op elsewhere.
  initWebStudio();

  // Portfolio parallax rows: Web Studio "Selected work" + klikdigital/our-portfolio.
  initPortfolioParallax();

  // Real Results From Our Portfolio: turn the case-study grid into a wide
  // Swiper slider and inject the arrows + "1/3" counter + mobile dots.
  initPortfolioResults();

  // Portfolio Grid (main Portfolio page): filter tags show/hide the top-3
  // cards + list rows by portfolio_services category.
  initPortfolioGrid();

  // Deployment & Integration Roadmap: scroll-scrubbed lime line-fill + step
  // activation on the vertical timeline.
  initRoadmap();

  // Back to Top: fixed bottom-right button, appears after 10% scroll,
  // click glides back to the top of the page (Lenis-aware).
  initBackToTop();

  // Button arrows: wrap the trailing arrow glyph of every .btn /
  // .wp-block-button__link label in a span so it can slide on hover.
  initButtonArrows();

  // Website Brief: multi-step controller for the interactive project
  // brief CF7 form (template-website-brief.php). No-op elsewhere.
  initWebsiteBrief();

  // Contact Form 7: block double submits so validation tips can't stack up.
  initContactForms();

  // Support Ticket popup: "Open Support Ticket" opens the CF7 modal, with
  // custom dropdowns, a drag & drop zone and the success panel.
  initSupportPopup();

  // Scroll reveal: fade sections and their cards in as they enter the viewport.
  initReveal();
});
